import React, { useState } from 'react';

function Quiz({ questions }) {
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);

  const handleAnswerSelect = (questionIndex, optionIndex) => {
    setSelectedAnswers({
      ...selectedAnswers,
      [questionIndex]: optionIndex
    });
  };

  const checkAnswers = () => {
    let correctCount = 0;
    
    questions.forEach((question, index) => {
      if (selectedAnswers[index] === question.correct) {
        correctCount++;
      }
    });
    
    setScore(correctCount);
    setShowResults(true);
  };

  const resetQuiz = () => {
    setSelectedAnswers({});
    setShowResults(false);
    setScore(0);
  };

  if (!questions || questions.length === 0) {
    return <p>No quiz questions available.</p>;
  }

  return (
    <div className="quiz-container">
      
      {questions.map((question, questionIndex) => (
        <div key={questionIndex} className="quiz-question">
          <p className="question-text">{question.question}</p>
          
          <div className="options-container">
            {question.options.map((option, optionIndex) => (
              <label 
                key={optionIndex} 
                className={`option-label ${
                  showResults && optionIndex === question.correct ? 'correct' : ''
                } ${
                  showResults && selectedAnswers[questionIndex] === optionIndex && 
                  optionIndex !== question.correct ? 'incorrect' : ''
                }`}
              >
                <input 
                  type="radio" 
                  name={`question-${questionIndex}`} 
                  checked={selectedAnswers[questionIndex] === optionIndex}
                  onChange={() => handleAnswerSelect(questionIndex, optionIndex)}
                  disabled={showResults}
                />
                <span className="option-text">{option}</span>
              </label>
            ))}
          </div>

          {showResults && (
            <div className="answer-feedback">
              {selectedAnswers[questionIndex] === question.correct ? (
                <p className="correct-feedback">Correct!</p>
              ) : (
                <p className="incorrect-feedback">
                  Incorrect. The correct answer is: {question.options[question.correct]}
                </p>
              )}
            </div>
          )}
        </div>
      ))}
      
      <div className="quiz-controls">
        {showResults ? (
          <>
            <div className="score-display">
              <p>Your score: {score} out of {questions.length}</p>
              <p className="score-message">
                {score === questions.length ? 'Perfect score! Great job!' : 
                 score >= questions.length * 0.7 ? 'Good job! Keep learning!' : 
                 'Keep exploring and learning!'}
              </p>
            </div>
            <button onClick={resetQuiz} className="quiz-button reset-button">
              Try Again
            </button>
          </>
        ) : (
          <button 
            onClick={checkAnswers} 
            className="quiz-button check-button"
            disabled={Object.keys(selectedAnswers).length < questions.length}
          >
            Check Answers
          </button>
        )}
      </div>
    </div>
  );
}

export default Quiz;